 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTTITLEPAGE from '@/components/Text/titlepage'
 import LOVE_1 from '@/components/love_1'
 import TEXTTITLE from '@/components/Text/Title'
 import TEXTCOPYRIGHT from '@/components/Text/Copyright'
 import TEXTTOC from '@/components/Text/TOC'
 import TEXTACKNOWLEDGMENTS from '@/components/Text/Acknowledgments'
 import TEXTPREFACE from '@/components/Text/Preface'
 import TEXTCHAPTER_01 from '@/components/Text/Chapter_01'
 import TEXTCHAPTER_02 from '@/components/Text/Chapter_02'
 import TEXTCHAPTER_03 from '@/components/Text/Chapter_03'
 import TEXTCHAPTER_04 from '@/components/Text/Chapter_04'
 import TEXTCHAPTER_05 from '@/components/Text/Chapter_05'
 import TEXTCHAPTER_06 from '@/components/Text/Chapter_06'
 import TEXTCHAPTER_07 from '@/components/Text/Chapter_07'
 import TEXTCHAPTER_08 from '@/components/Text/Chapter_08'
 import TEXTCHAPTER_09 from '@/components/Text/Chapter_09'
 import TEXTCHAPTER_10 from '@/components/Text/Chapter_10'
 import TEXTCHAPTER_11 from '@/components/Text/Chapter_11'
 import TEXTCHAPTER_12 from '@/components/Text/Chapter_12'
 import TEXTCHAPTER_13 from '@/components/Text/Chapter_13'
 import TEXTCHAPTER_14 from '@/components/Text/Chapter_14'
 import TEXTCHAPTER_15 from '@/components/Text/Chapter_15'
 import TEXTCHAPTER_16 from '@/components/Text/Chapter_16'
 import TEXTCHAPTER_17 from '@/components/Text/Chapter_17'
 import TEXTCHAPTER_18 from '@/components/Text/Chapter_18'
 import TEXTCHAPTER_19 from '@/components/Text/Chapter_19'
 import TEXTCHAPTER_20 from '@/components/Text/Chapter_20'
 import TEXTCHAPTER_21 from '@/components/Text/Chapter_21'
 import LOVE_2 from '@/components/love_2'
 import TEXTCTA from '@/components/Text/CTA'
 import TEXTWRECKINGCREW_EXCERPTAD from '@/components/Text/WRECKINGCREW_ExcerptAd'
 import TEXTPLAYINGDEAD_EXCERPTAD from '@/components/Text/PLAYINGDEAD_ExcerptAd'
 import TEXTTBIL_ADEXCERPT from '@/components/Text/TBIL_AdExcerpt'
 import TEXTTRUECRIMEADPAGE3 from '@/components/Text/TrueCrime-AdPage3'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/titlepage",
 			"name" : "Text/titlepage",
 			"component" : TEXTTITLEPAGE
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Text/Title",
 			"name" : "Text/Title",
 			"component" : TEXTTITLE
 		},
 		{
 			"path" : "/Text/Copyright",
 			"name" : "Text/Copyright",
 			"component" : TEXTCOPYRIGHT
 		},
 		{
 			"path" : "/Text/TOC",
 			"name" : "Text/TOC",
 			"component" : TEXTTOC
 		},
 		{
 			"path" : "/Text/Acknowledgments",
 			"name" : "Text/Acknowledgments",
 			"component" : TEXTACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/Text/Preface",
 			"name" : "Text/Preface",
 			"component" : TEXTPREFACE
 		},
 		{
 			"path" : "/Text/Chapter_01",
 			"name" : "Text/Chapter_01",
 			"component" : TEXTCHAPTER_01
 		},
 		{
 			"path" : "/Text/Chapter_02",
 			"name" : "Text/Chapter_02",
 			"component" : TEXTCHAPTER_02
 		},
 		{
 			"path" : "/Text/Chapter_03",
 			"name" : "Text/Chapter_03",
 			"component" : TEXTCHAPTER_03
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js